import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDrawer } from '@angular/material/sidenav';
import { AuthService } from '@excelway/services/auth.service';
import { AuthzService } from '@excelway/services/authz.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-project-settings',
  templateUrl: './project-settings.component.html',
  styleUrls: ['./project-settings.component.scss'],
})
export class ProjectSettingsComponent implements OnInit {
  @ViewChild('drawer') drawer: MatDrawer;
  drawerMode: 'over' | 'side' = 'side';
  drawerOpened: boolean = true;
  panels: any[] = [
    {
      id: 'object-details',
      icon: 'heroicons_outline:information-circle',
      title: "Détails de l'espace",
      description: " Gérez les informations et les actions de l'espace",
    },
    {
      id: 'access-invites',
      icon: 'heroicons_outline:user-group',
      title: 'Accès et invitations',
      description: " Contrôlez l'accès à l'espace",
    },
  ];
  selectedPanel: string = 'object-details';
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  role: string;

  /**
   * Constructor
   */
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data,
    private _changeDetectorRef: ChangeDetectorRef,
    public _matDialogRef: MatDialogRef<ProjectSettingsComponent>,
    private _authService: AuthService,
    private _authzService: AuthzService
  ) {
    // Initialize the selected panel based on the provided data
    if (data.tapToOpen) {
      this.selectedPanel = this.data.tabToOpen;
    } else {
      this.selectedPanel = data.selectedPanel || 'object-details';
    }
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Navigate to the panel
   *
   * @param panel
   */

  ngOnInit(): void {
    this.getUserRole();
    this._changeDetectorRef.detectChanges();
  }

  getUserRole(): void {
    this._authService.getAuthUser().then(identity => {
      if (identity) {
        this._authzService
          .fetchUserRole(this.data.id, identity.id)
          .subscribe(response => {
            this.role = response.role;
            this._authzService.setRole(this.role);
            this._changeDetectorRef.detectChanges();
          });
      }
    });
  }

  goToPanel(panel: string): void {
    this.selectedPanel = panel;

    // Close the drawer on 'over' mode
    if (this.drawerMode === 'over') {
      this.drawer.close();
    }
  }

  /**
   * Get the details of the panel
   *
   * @param id
   */
  getPanelInfo(id: string): any {
    console.log(this.panels.find(panel => panel.id === id));
    return this.panels.find(panel => panel.id === id);
  }

  /**
   * Track by function for ngFor loops
   *
   * @param index
   * @param item
   */
  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
}
